/** Stale-data detection: a value older than N minutes must not look live. */
export function staleAfterMinutes(metricOverride: number | null | undefined, orgDefault: number): number {
  return metricOverride ?? orgDefault;
}

/** Epoch ms at which a value observed at `observedAt` becomes stale. */
export function staleDeadline(observedAt: number, afterMinutes: number): number {
  return observedAt + afterMinutes * 60_000;
}

/** Stale when there is no value at all, or when it is older than the limit (the boundary itself is still fresh). */
export function isStale(observedAt: number | null | undefined, now: number, afterMinutes: number): boolean {
  if (observedAt == null || !Number.isFinite(observedAt)) return true;
  return now > staleDeadline(observedAt, afterMinutes);
}
